// Define route paths centrally to avoid hardcoding
export const ROUTES = {
  HOME: '/',
  EDTREATMENT: '/ed-treatment',
  EDQUESTIONNAIRE: '/ed-treatment/questionnaire',
  EDRESULTS: '/ed-treatment/results',
  EDUPSELL: '/ed-treatment/upsell',
  EDCOMPLETEORDER: '/ed-treatment/complete-order',
  CHECKOUTRETURN: '/checkout/return',
  WEIGHTLOSSTREATMENT: 'http://omniform1.com/forms/v1/landingPage/68b17b8ecfa3b70cffc68936/69240ca67ec3421d14fc356d',
  LOGIN: '/login',
  SIGNUP: '/signin',
  ACCOUNT: '/account',
  ACCOUNTSUBSCRIPTIONS: '/account/subscriptions',
  ACCOUNTDELIVERIES: '/account/deliveries',
  ADMIN_LOGIN: '/admin/login',
  ADMIN: '/admin',
  FORGOT_PASSWORD: '/forgot-password',
  DASHBOARD: '/dashboard',
  TEMPLATES: '/templates',
  FEATURES: '/features',
  PRICING: '/pricing',
  UNAUTHORIZED: '/unauthorized',
  CLIENTS: '/clients',
  PRIVACYPOLICY: '/privacy-policy',
  TERMSOFUSE: '/terms-of-use',
  TERMSOFSUPPLY: '/terms-of-supply',
};

// Define which routes require authentication
export const PROTECTED_ROUTES = [ROUTES.DASHBOARD, ROUTES.TEMPLATES];

// Default redirect route for authenticated users
export const DEFAULT_AUTHENTICATED_ROUTE = ROUTES.DASHBOARD;

// Default redirect route for unauthenticated users
export const DEFAULT_UNAUTHENTICATED_ROUTE = ROUTES.LOGIN;
